import { Fab, Icon, makeStyles } from "@material-ui/core";
import { useMap } from "react-leaflet";

const useStyles = makeStyles({
  zoomBtn: {
    position: "absolute",
    top: 0,
    bottom: "auto",
    left: 0,
    right: "auto",
    marginTop: 10,
    marginLeft: 10,
    zIndex: 400,
  },
});

const MapZoomOut = ({ initialPos }) => {
  const classes = useStyles();
  const map = useMap();

  return (
    <Fab
      className={classes.zoomBtn}
      variant="circular"
      color="primary"
      size="small"
      centerRipple
      onClick={() => map.setView(initialPos.center, initialPos.zoom)}
    >
      <Icon>zoom_out_map</Icon>
    </Fab>
  );
};

export default MapZoomOut;
